define(["require", "exports", "knockout", "UI/Context"], function (require, exports, ko, Context_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.TrackPage = exports.TrackEvent = exports.LineSourceTracking = void 0;
    class LineSourceTracking {
        constructor(data) {
            this.AppendTo = (other) => {
                const thisSource = this.Source.peek();
                const thisSourceType = this.SourceType.peek();
                const thisContext = this.Context.peek();
                const thisRelatedId = this.RelatedId.peek();
                const thisSearchId = this.SearchId.peek();
                const thisSearchTerm = this.SearchTerm.peek();
                const thisIndex = this.Index.peek();
                const otherSource = other.Source.peek();
                const otherSourceType = other.SourceType.peek();
                const otherContext = other.Context.peek();
                const otherRelatedId = other.RelatedId.peek();
                const otherSearchId = other.SearchId.peek();
                const otherSearchTerm = other.SearchTerm.peek();
                const otherIndex = other.Index.peek();
                if (!otherSource && thisSource)
                    other.Source(thisSource);
                if (!otherSourceType && thisSourceType)
                    other.SourceType(thisSourceType);
                if (!otherContext && thisContext)
                    other.Context(thisContext);
                if (otherRelatedId == null && thisRelatedId != null)
                    other.RelatedId(thisRelatedId);
                if (!otherSearchId && thisSearchId)
                    other.SearchId(thisSearchId);
                if (!otherSearchTerm && thisSearchTerm)
                    other.SearchTerm(thisSearchTerm);
                if (otherIndex == null && thisIndex != null)
                    other.Index(thisIndex);
                return other;
            };
            this.AddToProductTracking = (item) => {
                if (this.Source() != null) {
                    item.item_list_id = this.Source();
                    if (this.SourceType() != null) {
                        item.item_list_id = `${this.SourceType()}: ${item.item_list_id}`;
                    }
                    if (this.Index() != null) {
                        item.index = this.Index();
                    }
                    if (this.Context() != null) {
                        item.item_list_name = this.Context();
                    }
                }
                return item;
            };
            this.AddToUrl = (url, qsPrefix = "recommendation") => {
                var tracking = [];
                var parameters = [
                    ["Source", this.Source()],
                    ["Type", this.SourceType()],
                    ["Context", this.Context()],
                    ["Id", this.RelatedId()],
                    ["SearchId", this.SearchId()],
                    ["SearchTerm", this.SearchTerm()],
                    ["Index", this.Index()]
                ];
                ko.utils.arrayForEach(parameters, p => {
                    if (p[1] != null && (typeof p[1] !== 'string' || p[1].length > 0)) {
                        tracking.push(qsPrefix + p[0] + "=" + encodeURIComponent(p[1]));
                    }
                });
                if (tracking.length == 0)
                    return url;
                var qsSymbol = url.indexOf('?') > -1 ? '&' : '?';
                return url + qsSymbol + tracking.join('&');
            };
            ko.mapping.fromJS(data, {}, this);
            this.Source = this.Source || ko.observable();
            this.SourceType = this.SourceType || ko.observable();
            this.Context = this.Context || ko.observable();
            this.RelatedId = this.RelatedId || ko.observable();
            this.SearchId = this.SearchId || ko.observable();
            this.SearchTerm = this.SearchTerm || ko.observable();
            this.Index = this.Index || ko.observable();
            this.Data = ko.computed(() => ({
                Source: this.Source(),
                SourceType: this.SourceType(),
                Context: this.Context(),
                RelatedId: this.RelatedId(),
                SearchId: this.SearchId(),
                SearchTerm: this.SearchTerm(),
                Index: this.Index()
            }));
        }
        static FromRequest(qsPrefix = "recommendation") {
            const data = {
                Source: null,
                SourceType: null,
                Context: null,
                RelatedId: null,
                SearchTerm: null,
                SearchId: null,
                Index: null
            };
            const qs = window.location.search;
            if (qs == null || qs.length == 0)
                return new LineSourceTracking(data);
            const parameterMap = [
                [qsPrefix + "Source", x => data.Source = x],
                [qsPrefix + "Type", x => data.SourceType = x],
                [qsPrefix + "Context", x => data.Context = x],
                [qsPrefix + "Id", x => data.RelatedId = x],
                [qsPrefix + "SearchId", x => data.SearchId = x],
                [qsPrefix + "SearchTerm", x => data.SearchTerm = x],
                [qsPrefix + "Index", x => data.Index = parseInt(x)]
            ];
            const parameters = qs.substring(1).split('&');
            ko.utils.arrayForEach(parameters, p => {
                var values = p.split('=');
                if (values.length == 2) {
                    var parameter = ko.utils.arrayFirst(parameterMap, p => p[0] == values[0]);
                    if (parameter)
                        parameter[1](decodeURIComponent(values[1]));
                }
            });
            return new LineSourceTracking(data);
        }
    }
    exports.LineSourceTracking = LineSourceTracking;
    function TrackEvent(trackingStack) {
        var data = {
            Category: null,
            Action: null,
            Label: null
        };
        var appendValueToData = (key, value) => {
            if (value == null || value == "")
                return;
            if (data[key] == null || data[key] == "") {
                data[key] = value;
                return;
            }
            data[key] += `|${value}`;
        };
        trackingStack
            .forEach(obj => {
            if (obj == null)
                return;
            for (var key in data) {
                var value = obj[key];
                appendValueToData(key, value);
            }
        });
        Context_1.default.Sequence(Context_1.default.Sequence() + 1);
        var allEmpty = ![data.Category, data.Action, data.Label]
            .some(x => x != null && x.length > 0);
        if (allEmpty)
            return;
        var isNullOrEmpty = x => x == null || x.length == 0;
        if (isNullOrEmpty(data.Category))
            data.Category = "Uncategorized";
        if (isNullOrEmpty(data.Action))
            data.Action = "Unknown";
        if (isNullOrEmpty(data.Label))
            data.Label = "Unknown";
        if (Context_1.default.IsDev()) {
            console.log("Tracking:", data.Category, data.Action, data.Label);
        }
        else {
            StullerTrackEvent(data.Category, data.Action, data.Label);
        }
    }
    exports.TrackEvent = TrackEvent;
    function TrackPage(page) {
        let pageURL = page || window.location.href;
        __gaTracker('set', 'page', pageURL);
        let pageViewObj = {
            'page': pageURL,
            'dimension1': Context_1.default.LoginId() ? "Yes" : "No",
            'dimension2': Context_1.default.IsInShowcase() ? "Yes" : "No",
            'dimension3': Context_1.default.UserMemberId() || "None",
            'dimension4': Context_1.default.SessionId() || "None",
            'dimension7': Context_1.default.SearchEngine() || ""
        };
        if (!pageViewObj.dimension7) {
            delete pageViewObj["dimension7"];
        }
        __gaTracker('send', 'pageview', pageViewObj);
    }
    exports.TrackPage = TrackPage;
});
//# sourceMappingURL=Tracking.js.map